export default __webpack_public_path__ + "static/cer-3-a2d4f492c2d3ffe42d73bf0c6ecb391d.webp";